import React from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import PageTabs from '../../../components/PageTabs';
import {
  ChartBar as BarChart3,
  Bell,
} from '@phosphor-icons/react';

/**
 * Wrapper that adds PageTabs above the Sales (Revenue) page.
 * The actual Sales component is rendered via KeepAliveTabs in TenantRoutes.
 */
const SalesTab = ({ children, darkMode, ...props }) => {
  const { slug } = useParams();
  const { user } = useAuth();
  const isRestaurantType = ['FOOD_AND_BEVERAGE', 'RESTAURANT'].includes(user?.businessType);

  const tabs = [
    { key: 'revenue', label: 'Revenue', icon: BarChart3, path: `/${slug}/owner/sales` },
    { key: 'voids', label: isRestaurantType ? 'Cancel Orders' : 'Void Requests', icon: Bell, path: `/${slug}/owner/sales/voids` },
  ];

  return (
    <>
      <PageTabs tabs={tabs} darkMode={darkMode} />
      {children}
    </>
  );
};

export default SalesTab;
